import styled from "styled-components"

const Container = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 10000000;
`;

const Body = styled.div`
  width: 50%;
  height: auto;
  background-color: white;
  border-radius: 1rem;
  position: relative;
  padding: 2rem;
`;

const CloseButton = styled.button`
  width: 3rem;;
  height: 3rem;
  background-color: red;
  border-radius: 3rem;
  color: white;
  position: absolute;
  right: 3rem;
  top: 3rem;
`;

function Modal({ children, onClose }) {
  return (
    <Container className="d-flex justify-content-center align-items-center">
      <CloseButton onClick={onClose} className="d-flex justify-content-center align-items-center">
        <i className="mdi mdi-window-close"></i>
      </CloseButton>
      
      <Body>
        {children}
      </Body>
    </Container>
  );
}

export default Modal;